import React, { useState, useEffect } from 'react';
import {
  withAITracking,
  useAppInsightsContext,
} from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from '../utils/ApplicationInsightsService';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';


import LandPageCarousel from './LandingPageCarousel';
import QnAContent from './QAContent';
import BMyTurnContent from './BlueMyTurnContent';

function LandingPage({ htmlDir, settings }) {
  const appInsights = useAppInsightsContext();
  // const { t, i18n } = useTranslation();
  // const currentLanguage = i18n.language;
  // const isArabic = currentLanguage === "ae";

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    pageLoaded();
  }, []);

  const pageLoaded = () => {
    appInsights.trackEvent({ name: 'Landing page loaded' });
  };

  const { _height, width } = useWindowDimensions();

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(
      getWindowDimensions(),
    );

    useEffect(() => {
      function handleResize() {
        setWindowDimensions(getWindowDimensions());
      }

      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
  }

  function pressRequestRecordButton() {
    appInsights.trackEvent({ name: 'Request Record Button Pressed' });
  }

  function pressVALink() {
    appInsights.trackEvent({ name: 'Landing Page VAT Link Pressed' });
  }

  const { _i18n } = useTranslation();

  return (
    <div>
      {/* Title banner */}
      <div className="LandingRoot">
        <div className="LandingContainer">
          <div
            className={
              htmlDir === 'rtl' ? 'TitleContainer rtl' : 'TitleContainer'
            }
          >
            <div>
              <h1 className="LandingPageH1">
                <Trans i18nKey="landingPage.title">
                  Digital Vaccine Record
                </Trans>
              </h1>
              <h2 className="LandingPageH2">
                <Trans i18nKey="landingPage.subtitle">
                  California's Vaccine Record Site
                </Trans>
              </h2>
              <p className="LandingPagePara">
                <Trans i18nKey="landingPage.instructions">
                  To get a digital copy of your Digital Vaccine Record (DVR),
                  just enter a few details. You can get a link to your COVID-19
                  Vaccine Record with a QR code or your California Immunization
                  Record. Save it on your phone and use it as proof of
                  vaccination wherever you go.
                </Trans>
              </p>
              <Link to="/request" style={{ margin: '0' }} tabIndex={-1}>
                <button
                  type="button"
                  className="bttnStyle"
                  onClick={pressRequestRecordButton}
                >
                  <Trans i18nKey="landingPage.requestRecord">
                    Request Record
                  </Trans>
                </button>
              </Link>
            </div>
          </div>
          {width > 950 ? (
            <div className="HomePageImageContainer">
              <img
                className="HomePageImage"
                aria-label="woman and two children using tablet"
                src="/imgs/Home_page_image.svg"
              />
            </div>
          ) : (
            <div
              className="bkg"
              style={{ backgroundImage: "url('/imgs/Home_page_image.svg')" }}
            />
          )}
        </div>
      </div>
      <div>
        <h2 className='included'><Trans i18nKey="landingPage.includedTitle">What's included in my DVR?</Trans></h2>
        <h4 className='access'><Trans i18nKey="landingPage.includedSubtitle">In your DVR, youll have access to:</Trans></h4>
        <div className='includedContainer'>
          <div className='immunizationRecordSection'>
            <img src='/imgs/full_DVR_icon.svg' className='immunizationRecordImage'></img>
            <h3 className='immunizationRecordHeader'><Trans i18nKey="landingPage.immunizationRecordHeader">CA Immunization Record</Trans></h3>
            <ul>
              <li><Trans i18nKey="landingPage.immunizationRecord1">Printable record of all your vaccinations reported to CAIR by your healthcare provider and pharmacy</Trans></li>
              <li><Trans i18nKey="landingPage.immunizationRecord2">Up-to-date, recommended, and overdue vaccinations based on CDC guidelines</Trans></li>
              <li><Trans i18nKey="landingPage.immunizationRecord3">Routine, childhood, and/or adult vaccinations</Trans></li>
            </ul>
          </div>
        <div className='covid19VaccineRecordSection'>
          <img src='/imgs/covid_icon.svg' className='covid19VaccineRecordImage'></img>
          <h3 className='covid19VaccineRecordHeader'>
            <Trans i18nKey="landingPage.covid19VaccineRecordHeader">COVID-19 Vaccine Record</Trans>
          </h3>
          <ul>
            <li><Trans i18nKey="landingPage.covid19VaccineRecord1">QR code for digital verification</Trans></li>
            <li><Trans i18nKey="landingPage.covid19VaccineRecord2">Vaccine brand (e.g., Pfizer, Moderna, J&J)</Trans></li>
            <li><Trans i18nKey="landingPage.covid19VaccineRecord3">Dose dates (most recent 8 doses)</Trans></li>
            <li><Trans i18nKey="landingPage.covid19VaccineRecord4">Vaccine manufacturer</Trans></li>
          </ul>
        </div>
      </div>
      </div>
      <div>
        <QnAContent htmlDir={htmlDir} settings={settings} />
      </div>
      <div>
        <div className='myTurnContainer'>
          <BMyTurnContent htmlDir={htmlDir} />
          
        </div>
      </div>
      <div className='needHelpContainer'>
        <div className='needHelpTextContainer'>
          <img className='needHelpImage' src='/imgs/need_help_icon.svg'></img>
          
          <h2 className='needHelpTitle'>
            <Trans i18nKey="landingPage.needHelpTitle">Need to update or locate your DVR?</Trans>
          </h2>
          
          <p className='needHelpVA'>
            <Trans i18nKey="landingPage.needHelpVA">Submit a request through the <a
                                    href={settings.VATLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={pressVALink}
                                    style={{
                                        color: "#0d6efd",
                                        margin: "0",
                                        textDecoration: "underline",
                                    }}
                                    >
                                    Virtual Assistant
                                </a> We're unable to locate or update your DVR over the phone.</Trans>
          </p>
    
          <p className='needHelpNote'>
            <Trans i18nKey="landingPage.needHelpNote">NOTE: If your DVR is missing vaccines, please work with your health care provider to ensure all vacccine dose information has been submitted to a California immunization registry. The CAIR Help Desk cannot add doses information to you immunization record.</Trans>
          </p>
        </div>
      </div>
    </div>
  );
}

export default withAITracking(reactPlugin, LandingPage, 'LandingPage');
